import { Document } from "@/model/document2/document";

import { EncryptionHelper } from "./encryptionHelper"
import { DebugHelper } from "@/helper/debugHelper";
import { Const } from '@/const';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';
import { Design } from '@/model/document2/page/surface/design/design';
import { ImageHelper } from './imageHelper';
import { StringHelper } from './stringHelper';
import { UserAgentHelper } from './userAgentHelper';
import { ZipCompressor } from "@/lib/zipCompressor";
import { ZipDecompressor } from "@/lib/zipDecompressor";

import { FileConverter } from "@/label_convert/fileConverter";
import { FontManager } from '@/model/fontManager/fontManager';
import { JsonHelper } from './jsonHelper';
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';
import { TableLayer } from '@/model/document2/page/surface/design/layer/tableLayer';
import { TableCellInfo } from '@/model/document2/page/surface/design/layer/table/tableCellInfo';
import { GroupLayer } from '@/model/document2/page/surface/design/layer/groupLayer';

export class FileHelper
{
    static readonly DOCUMENT_FOLDER_NAME = "document";
    static readonly DOCUMENT_CONTENT_FILE_NAME = "document";
    static readonly DOCUMENT_CONTENT_FILE_EXT = ".data";
    static readonly IMAGE_FILE_NAME_PREFIX = "image";
    static readonly IMAGE_WHITETRANSPARENT_FILE_NAME_PREFIX = "imagew";
    static readonly IMAGE_ORIGN_FILE_NAME_PREFIX = "imageo";
    static readonly IMAGE_WHITETRANSPARENT_ORIGN_FILE_NAME_PREFIX = "imageo";
    static readonly IMAGE_THUMBNAIL_FILE_NAME_PREFIX = "imaget";
    static readonly IMAGE_THUMBNAIL_WHITETRANSPARENT_FILE_NAME_PREFIX = "imagetw";
    static readonly IMAGE_FILE_NAME_SEPARATOR = "_";
    static readonly IMAGE_EXT = ".i";

    // ドキュメントを得る *引数がstringの場合でも対応
    public static loadDocumentAnyway(data : ArrayBuffer | Uint8Array | string)
    {
        if(typeof data == "string")
        {
            data = EncryptionHelper.compositeIfNeeded(data);
            if(JsonHelper.isJSON(data))
            {
                var doc = Document.createFromJsonData(JSON.parse(data));
                FileHelper.decodeDocumentImage(doc);
                doc.updateHash();

                return doc;
            }
            else
            {
                // DataUrl or Base64 だと思われる
                try
                {
                    var dataArray = data.split(",");
                    var b64 = dataArray[dataArray.length - 1];
                    // base64 -> BinaryString
                    var bs = window.atob(b64);
                    // BindaryString -> Uint8Array
                    var uint8Array = this.convertBinaryStringToBuffer(bs);
                    return this.loadDocument(uint8Array.buffer as ArrayBuffer);
                }
                catch
                {
                    return null;
                }
            }
        }
        else if(data instanceof Uint8Array)
        {
            return this.loadDocument(data.buffer as ArrayBuffer);
        }
        else 
        {
            return this.loadDocument(data);
        }
    }

    // ドキュメントを得る
    public static loadDocument(buffer : ArrayBuffer)
    {
        var doc : Document | null = null;
        try
        {
            // Zip圧縮解除
            var unzip = new ZipDecompressor(buffer);
            var files = unzip.getFilenames()
            if(files != null)
            {
                // Document作成
                for(var i = 0; i < files.length; ++i)
                {
                    var file = files[i];
                    var ext = "." + FileHelper.getFileExtension(file);
                    if(ext.toLowerCase() == FileHelper.DOCUMENT_CONTENT_FILE_EXT.toLowerCase())
                    {
                        // コンテンツjsonファイル
                        var content = unzip.decompressFile(file);
                        if(content != null)
                        {
                            var docJson = StringHelper.utf8ArrayToStr(content);
                            // デバッグバージョンで暗号化されている場合がある
                            docJson = EncryptionHelper.compositeIfNeeded(docJson);
                            doc = Document.createFromJsonData(JSON.parse(docJson));
                        }
                    }

                    if(doc != null) break;
                }

                // Documentの画像をデコード
                if(doc != null)
                {
                    var images : { [ index : number] : string } = {};
                    var imagesWhiteTransparent : { [ index : number] : string } = {};
                    var imagesOrigin : { [ index : number] : string } = {};
                    var imagesWhiteTransparentOrigin : { [ index : number] : string } = {};
                    var imagesThumbnail : { [ index : number] : string } = {};
                    var imagesThumbnailWhiteTransparent : { [ index : number] : string } = {};
                    for(var i = 0; i < files.length; ++i)
                    {
                        var file = files[i];
                        var ext = "." + FileHelper.getFileExtension(file);
                        if(ext.toLowerCase() == FileHelper.IMAGE_EXT.toLowerCase())
                        {
                            // 画像ファイル
                            var imageBuf = unzip.decompressFile(file);
                            if(imageBuf != null)
                            {
                                // buffer -> base64

                                var base64 = ImageHelper.convertBufferToBase64(imageBuf);

                                // セパレータで分けてファイル名解析
                                var baseName = FileHelper.getFullBaseName(file);
                                var fileWords = FileHelper.getFilenameWithoutExtension(baseName).split(FileHelper.IMAGE_FILE_NAME_SEPARATOR);
                                if(fileWords.length >= 2)
                                {
                                    var prefix = fileWords[0];
                                    var index = parseInt(fileWords[1]);

                                    if(prefix == FileHelper.IMAGE_FILE_NAME_PREFIX) images[index] = base64;
                                    else if(prefix == FileHelper.IMAGE_WHITETRANSPARENT_FILE_NAME_PREFIX) imagesWhiteTransparent[index] = base64;
                                    else if(prefix == FileHelper.IMAGE_ORIGN_FILE_NAME_PREFIX) imagesOrigin[index] = base64;
                                    else if(prefix == FileHelper.IMAGE_WHITETRANSPARENT_ORIGN_FILE_NAME_PREFIX) imagesWhiteTransparentOrigin[index] = base64;
                                    else if(prefix == FileHelper.IMAGE_THUMBNAIL_FILE_NAME_PREFIX) imagesThumbnail[index] = base64;
                                    else if(prefix == FileHelper.IMAGE_THUMBNAIL_WHITETRANSPARENT_FILE_NAME_PREFIX) imagesThumbnailWhiteTransparent[index] = base64;
                                }
                            }
                        }
                    }
                    
                    // 画像の適用
                    this.loadDocumentImages(doc, images, imagesWhiteTransparent, imagesOrigin, imagesWhiteTransparentOrigin, imagesThumbnail, imagesThumbnailWhiteTransparent);
                    
                    if(doc.layerImageData != null && doc.layerImageData.length > 0)
                    {
                        // 旧バージョン対応で画像をデコードする。
                        FileHelper.decodeDocumentImage(doc);
                    }
                }
            }
            unzip.dispose();

            if(doc == null)
            {
                // テキストとして読む
                var docJson = StringHelper.utf8ArrayToStr(new Uint8Array(buffer));
                docJson = EncryptionHelper.compositeIfNeeded(docJson);
                doc = Document.createFromJsonData(JSON.parse(docJson));
                // イメージのデコード
                FileHelper.decodeDocumentImage(doc);
            }

            // ハッシュ更新
            if(doc != null) doc.updateHash();
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        return doc;
    }

    // ドキュメントをLabel9のファイルデータから得る
    public static loadDocumentFromLabel9(buffer : ArrayBuffer, fontManager : FontManager)
    {
        var doc : Document | null = null;

        // Zip圧縮解除
        var unzip = new ZipDecompressor(buffer);
        var files = unzip.getFilenames()
        if(files != null)
        {
            for(var i = 0; i < files.length; ++i)
            {
                var file = files[i];
                var content = unzip.decompressFile(file);
                if(content != null)
                {
                    var docXml = StringHelper.utf8ArrayToStr(content);
                    try
                    {
                        var fileConverter = new FileConverter(fontManager);
                        doc = fileConverter.deserializeLabel9FromXml(docXml);
                    }
                    catch(e)
                    {
                        DebugHelper.trace(e);
                    }
                }

                if(doc != null) break;
            }
        }
        unzip.dispose();

        return doc;
    }

    // ドキュメントを圧縮して保存する
    public static saveDocumentAsZip(doc : Document, filename : string)
    {
        var buf = this.convertDocumentToSaveBuffer(doc);
        if(buf != null) 
        {
            var ext = doc.useInsertion ? Const.INSERTION_FILE_EXTENSION : Const.PROJECT_FILE_EXTENSION;
            
            let type = "application/zip";
            if(UserAgentHelper.getBrowser() == "firefox")
            {
                let majorVersion = FileHelper.getMajorVersion(UserAgentHelper.getBrowserVersion());
                if(majorVersion >= 84)
                {
                    // firefox 84.0以降はtypeの指定を変更しないと.zipで保存される
                    DebugHelper.trace("save as octet-stream.");
                    type = "application/octet-stream";
                }
            }

            this.saveBlob(new Blob([buf.buffer], { type: type }), filename + ext);
        }
    }

    public static convertBufferToBinaryString(binary : Uint8Array)
    {
        var i : number, len = binary.length, b_str = "";
        for (i = 0; i < len; ++i) 
        {
            b_str += String.fromCharCode(binary[i]);
        }
        return b_str;
    }

    public static convertBinaryStringToBuffer(bs : string)
    {
        try
        {
            var ab = new ArrayBuffer(bs.length);
            var u8Array = new Uint8Array(ab);
            for(var i = 0; i < bs.length; ++i)
            {
                u8Array[i] = bs.charCodeAt(i);
            }
            return u8Array;
        }
        catch(ex)
        {
            return new Uint8Array();
        }
    }

    // ドキュメントから保存バッファを作成する
    public static convertDocumentToSaveBuffer(doc : Document)
    {
        // Zip圧縮
        var zip = new ZipCompressor();
        // 画像エンコード
        this.saveDocumentImages(doc, zip);
        // document -> Json
        var docJson = JSON.stringify(doc);
        zip.addFile(FileHelper.DOCUMENT_FOLDER_NAME + "/" + FileHelper.DOCUMENT_CONTENT_FILE_NAME + FileHelper.DOCUMENT_CONTENT_FILE_EXT, StringHelper.strToUtf8Array(docJson));
        var buf = zip.compressFiles();
        zip.dispose();
        return buf;
    }

    // ドキュメントに含まれる画像を別ファイルとして保存する
    public static saveDocumentImages(doc : Document, zip : ZipCompressor)
    {
        var images : Array<string> = [];
        var imagesWhiteTransparent : Array<string> = [];
        var imagesOrigin : Array<string> = [];
        var imagesWhiteTransparentOrigin : Array<string> = [];
        var imagesThumbnail : Array<string> = [];
        var imagesThumbnailWhiteTransparent : Array<string> = [];
        var map : { [ id : string ] : number } = {};
        for(var pageIndex = 0; pageIndex < doc.pageCount; ++pageIndex)
        {
            var page = doc.pageList[pageIndex];
            for(var surfaceIndex = 0; surfaceIndex < (page.hasReverse ? 2 : 1); ++surfaceIndex)
            {
                var surface = page.getSurface(surfaceIndex == 1);
                for(var designIndex = 0; designIndex < page.designMaxNumber; ++designIndex)
                {
                    var design = surface.getDesign(designIndex);
                    if(design != null)
                    {
                        var allLayers = design.getAllLayers(false);
                        for(var i = 0; i < allLayers.length; ++i)
                        {
                            var layer = allLayers[i];
                            if(layer instanceof ImageLayer)
                            {
                                var image = layer.imageBase64;
                                var imageWhiteTransparent = layer.imageBase64WhiteTransparent;
                                var imageOrigin = layer.imageBase64Origin;
                                var imageWhiteTransparentOrigin = layer.imageBase64WhiteTransparentOrigin;
                                var imageThumbnail = layer.thumbnailImage;
                                var imageThumbnailWhiteTransparent = layer.thumbnailImageWhiteTransparent;
                                // 画像のオリジナルが同じ場合は保持しない
                                if(image == imageOrigin) { imageOrigin = ""; }
                                if(imageWhiteTransparent == imageWhiteTransparentOrigin) { imageWhiteTransparentOrigin = ""; }

                                // イメージが存在しているか？
                                var foundIndex = -1;
                                for(var j = 0; j < images.length; ++j)
                                {
                                    if(image == images[j])
                                    {
                                        // 存在
                                        foundIndex = j;
                                        break;
                                    }
                                }
                                if(foundIndex >= 0)
                                {
                                    // イメージが存在している
                                    map[layer.id] = foundIndex;
                                }
                                else
                                {
                                    // イメージが存在していない
                                    images.push(image);
                                    imagesWhiteTransparent.push(imageWhiteTransparent);
                                    imagesOrigin.push(imageOrigin);
                                    imagesWhiteTransparentOrigin.push(imageWhiteTransparentOrigin);
                                    imagesThumbnail.push(imageThumbnail);
                                    imagesThumbnailWhiteTransparent.push(imageThumbnailWhiteTransparent);
                                    map[layer.id] = images.length - 1;
                                }
                            }
                        }
                    }
                }
            }
        }

        // エンコードデータをファイルに保存していく
        var len = images.length;
        for(var i = 0; i < len; ++i)
        {
            try
            {
                var imageFileName = FileHelper.DOCUMENT_FOLDER_NAME + "/" + FileHelper.IMAGE_FILE_NAME_PREFIX + 
                    FileHelper.IMAGE_FILE_NAME_SEPARATOR + i + FileHelper.IMAGE_EXT;
                this.saveImageFromBase64(images[i], imageFileName, zip);
                var imageWTFileName = FileHelper.DOCUMENT_FOLDER_NAME + "/" + FileHelper.IMAGE_WHITETRANSPARENT_FILE_NAME_PREFIX + 
                    FileHelper.IMAGE_FILE_NAME_SEPARATOR + i + FileHelper.IMAGE_EXT;
                this.saveImageFromBase64(imagesWhiteTransparent[i], imageWTFileName, zip);
                var imageOrgFileName = FileHelper.DOCUMENT_FOLDER_NAME + "/" + FileHelper.IMAGE_ORIGN_FILE_NAME_PREFIX + 
                    FileHelper.IMAGE_FILE_NAME_SEPARATOR + i + FileHelper.IMAGE_EXT;
                this.saveImageFromBase64(imagesOrigin[i], imageOrgFileName, zip);
                var imageWTOrgFileName = FileHelper.DOCUMENT_FOLDER_NAME + "/" + FileHelper.IMAGE_WHITETRANSPARENT_ORIGN_FILE_NAME_PREFIX + 
                    FileHelper.IMAGE_FILE_NAME_SEPARATOR + i + FileHelper.IMAGE_EXT;
                this.saveImageFromBase64(imagesWhiteTransparentOrigin[i], imageWTOrgFileName, zip);
                var imageThumbnailFileName = FileHelper.DOCUMENT_FOLDER_NAME + "/" + FileHelper.IMAGE_THUMBNAIL_FILE_NAME_PREFIX + 
                    FileHelper.IMAGE_FILE_NAME_SEPARATOR + i + FileHelper.IMAGE_EXT;
                this.saveImageFromBase64(imagesThumbnail[i], imageThumbnailFileName, zip);
                var imageThumbnailWTFileName = FileHelper.DOCUMENT_FOLDER_NAME + "/" + FileHelper.IMAGE_THUMBNAIL_WHITETRANSPARENT_FILE_NAME_PREFIX + 
                    FileHelper.IMAGE_FILE_NAME_SEPARATOR + i + FileHelper.IMAGE_EXT;
                this.saveImageFromBase64(imagesThumbnailWhiteTransparent[i], imageThumbnailWTFileName, zip);
            }
            catch(e)
            {
                DebugHelper.trace(e);
            }
        }

        doc.layerImageMap = map;
    }

    // ドキュメントに含まれる画像をロードする
    public static loadDocumentImages(doc : Document,
        images : { [ index : number] : string }, 
        imagesWhiteTransparent : { [ index : number] : string },
        imagesOrigin : { [ index : number] : string },
        imagesWhiteTransparentOrigin : { [ index : number] : string },
        imagesThumbnail : { [ index : number] : string },
        imagesThumbnailWhiteTransparent : { [ index : number] : string })
    {
        for(var pageIndex = 0; pageIndex < doc.pageCount; ++pageIndex)
        {
            var page = doc.pageList[pageIndex];
            for(var surfaceIndex = 0; surfaceIndex < (page.hasReverse ? 2 : 1); ++surfaceIndex)
            {
                var surface = page.getSurface(surfaceIndex == 1);
                for(var designIndex = 0; designIndex < page.designMaxNumber; ++designIndex)
                {
                    var design = surface.getDesign(designIndex);
                    if(design != null)
                    {
                        var allLayers = design.getAllLayers(false);
                        for(var i = 0; i < allLayers.length; ++i)
                        {
                            var layer = allLayers[i];
                            if(layer instanceof ImageLayer)
                            {
                                if(layer.imageBase64 == "" || layer.imageBase64WhiteTransparent == "")
                                {
                                    // ドキュメントから復帰する
                                    if(doc.layerImageMap[layer.id] != null)
                                    {
                                        var index = doc.layerImageMap[layer.id];
                                        if(images[index] != null) layer.imageBase64 = images[index];
                                        if(imagesWhiteTransparent[index] != null) layer.imageBase64WhiteTransparent = imagesWhiteTransparent[index];
                                        if(imagesOrigin[index] != null) layer.imageBase64Origin = imagesOrigin[index]
                                        else layer.imageBase64Origin = layer.imageBase64;
                                        if(imagesWhiteTransparentOrigin[index] != null) layer.imageBase64WhiteTransparentOrigin = imagesWhiteTransparentOrigin[index]
                                        else layer.imageBase64WhiteTransparentOrigin = layer.imageBase64WhiteTransparent;
                                        if(imagesThumbnail[index] != null) layer.thumbnailImage = imagesThumbnail[index]
                                        if(imagesThumbnailWhiteTransparent[index] != null) layer.thumbnailImageWhiteTransparent = imagesThumbnailWhiteTransparent[index]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    public static saveImageFromBase64(base64Image : string, fileName : string, zip : ZipCompressor)
    {
        if(base64Image == "") return;
        try
        {
            // base64のデータ部分 -> binary
            var bin = atob(base64Image.split(',')[1].replace(/\r?\n/g, ""));
            // binary -> buffer
            var buffer = new Uint8Array(bin.length);
            for(var i = 0; i < bin.length; ++i)
            {
                buffer[i] = bin.charCodeAt(i);
            }
            zip.addFile(fileName, buffer);
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
    }

    // ドキュメントを保存する
    // ファイル名は拡張子を抜いて与える
    public static saveDocument(document : Document, filename : string)
    {
        this.saveDocumentCore(document, filename);
        // if(UserAgentHelper.isElectron() || document.useInsertion)
        // {
        //     // DL版 or 差し込みは通常保存する
        //     this.saveDocumentCore(document, filename);
        // }
        // else
        // {
        //     // そのほかはサムネイル生成ののち、保存する
        //     this.createDocumentThumbnailImage(document, () =>{
        //         this.saveDocumentCore(document, filename);
        //     });
        // }
    }

    private static saveDocumentCore(document : Document, filename : string)
    {
        // 画像エンコード
        this.encodeDocumentImage(document);

        // document -> json
        var json = JSON.stringify(document);

        // 暗号化はしない
        //json = EncryptionHelper.encrypt(json)

        // 拡張子付与
        var ext = document.useInsertion ? Const.INSERTION_FILE_EXTENSION : Const.PROJECT_FILE_EXTENSION;
        var fullFilename = filename + ext;

        // テキストファイル保存
        FileHelper.saveText(json, fullFilename);

        // ドキュメントのハッシュ更新
        document.updateHash();
    }

    // ドキュメントのダウンロードリンクを作成する
    public static createDocumentUrl(document : Document, filename : string)
    {
        // 画像エンコード
        this.encodeDocumentImage(document);
        // document -> json
        var json = JSON.stringify(document);
        // json -> blob
        var blob = new Blob([json], { type: 'text/plain;charset=utf-8;' });
        // blob -> url
        var url = this.createUrl(blob);

        return url;
    }

    // ドキュメントのjsonを返す
    public static getDocumentJson(document : Document)
    {
        // 画像エンコード
        this.encodeDocumentImage(document);

        return JSON.stringify(document);
    }

    public static saveText(text : string, filename : string)
    {
        var blob = new Blob([text], { type: 'text/plain;charset=utf-8;' });
        this.saveBlob(blob, filename);
    }

    public static saveCsv(csv : string, filename : string)
    {
        // 文字化け防止にbomを追加
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        var blob = new Blob([bom, csv], { type: 'text/csv' });
        this.saveBlob(blob, filename);
    }

    public static saveImage(base64Image : string, fileType : string, filename : string)
    {
        try
        {
            var type = fileType == "png" ? "image/png" : "image/jpeg";
            // base64のデータ部分 -> binary
            var bin = atob(base64Image.split(',')[1].replace(/\r?\n/g, ""));
            // binary -> buffer
            var buffer = new Uint8Array(bin.length);
            for(var i = 0; i < bin.length; ++i)
            {
                buffer[i] = bin.charCodeAt(i);
            }
            // buffer -> blob
            var blob = new Blob([buffer.buffer], {type : type});
            this.saveBlob(blob, filename);
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
    }

    public static createUrl(blob : Blob)
    {
        if(URL)
        {
            return URL.createObjectURL(blob);
        }
        else
        {
            return webkitURL.createObjectURL(blob);
        }
    }

    public static openBlob(blob : Blob, filename : string)
    {
        if(navigator.msSaveOrOpenBlob)
        {
            navigator.msSaveOrOpenBlob(blob, filename);
        }
        else
        {
            this.saveBlob(blob, filename);
        }
    }

    public static saveBlob(blob : Blob, filename : string)
    {
        if(navigator.msSaveBlob)
        {
            // IE 10+
            navigator.msSaveBlob(blob, filename);
        }
        else if(URL || webkitURL)
        {
            // Chrome, Safari, Firefox
            var url;
            if(URL)
            {
                url = URL.createObjectURL(blob);
            }
            else
            {
                url = webkitURL.createObjectURL(blob);
            }

            var a = document.createElement('a');
            a.href = url;
            a.download = filename;
            var platform = require('platform');
            if(platform.name == "Safari" && (FileHelper.getMajorVersion(platform.version) < 10 ||
                platform.version == "10.0" || platform.version == "10.0.1" || platform.version == "10.0.2"))
            {
                // Safari < 10.1 の場合は_blank必須
                a.target = '_blank';
            }
            // firefoxはappendChildしないとダウンロードできない
            document.body.appendChild(a);
            // クリックイベント呼び出し
            a.click();
            document.body.removeChild(a);
        }
    }

    private static getMajorVersion(version : string) : number
    {
        var major = "";
        var periodIndex = version.indexOf(".");
        if(periodIndex >= 0)
        {
            // ピリオド直前までを切り取る
            major = version.substr(0, periodIndex);
        }
        else
        {
            major = version;
        }

        return Number(major);
    }

    // 拡張子付き、フォルダ名なしのファイル名を取得する
    // 空文字の場合は空文字を返す
    public static getFullBaseName(filename: string): string {
        return filename.split(/[\/\\]/).slice(-1)[0];
    }

    // Url -> ファイル名
    public static getFilenameFromUrl(url : string, extension : boolean)
    {
        if(extension)
        {
            var match = url.match(".+/(.+?)([\?#;].*)?$");
            return match == null ? "" : match[1];
        }
        else
        {
            var match = url.match(".+/(.+?)\.[a-z]+([\?#;].*)?$");
            return match == null ? "" : match[1];
        }
    }

    // ファイル名から拡張子削除
    public static getFilenameWithoutExtension(filename : string)
    {
        var match = filename.match(/(.*)(?:\.([^.]+$))/);
        return match == null ? "" : match[1];
    }

    // ファイル名から拡張子取得
    public static getFileExtension(filename : string)
    {
        var match = filename.match(/(.*)(?:\.([^.]+$))/);
        return match == null ? "" : match[2];
    }

    // URLからファイル名取得
    public static getFileNameFromUrl(url : string, extension : boolean = true)
    {
        var match = extension ? url.match(".+/(.+?)([\?#;].*)?$") : url.match(".+/(.+?)\.[a-z]+([\?#;].*)?$");
        return match == null ? "" : match[1];
    }

    // ドキュメントに含まれるすべての画像データをエンコード
    public static encodeDocumentImage(document : Document)
    {
        var images : Array<string> = [];
        var imagesWhiteTransparent : Array<string> = [];
        var imagesOrigin : Array<string> = [];
        var imagesWhiteTransparentOrigin : Array<string> = [];
        var map : { [ id : string ] : number } = {};
        for(var pageIndex = 0; pageIndex < document.pageCount; ++pageIndex)
        {
            var page = document.pageList[pageIndex];
            for(var surfaceIndex = 0; surfaceIndex < (page.hasReverse ? 2 : 1); ++surfaceIndex)
            {
                var surface = page.getSurface(surfaceIndex == 1);
                for(var designIndex = 0; designIndex < page.designMaxNumber; ++designIndex)
                {
                    var design = surface.getDesign(designIndex);
                    if(design != null)
                    {
                        var allLayers = design.getAllLayers(false);
                        for(var i = 0; i < allLayers.length; ++i)
                        {
                            var layer = allLayers[i];
                            if(layer instanceof ImageLayer)
                            {
                                var image = layer.imageBase64;
                                var imageWhiteTransparent = layer.imageBase64WhiteTransparent;
                                var imageOrigin = layer.imageBase64Origin;
                                var imageWhiteTransparentOrigin = layer.imageBase64WhiteTransparentOrigin;
                                // 画像のオリジナルが同じ場合は保持しない
                                if(image == imageOrigin) { imageOrigin = ""; }
                                if(imageWhiteTransparent == imageWhiteTransparentOrigin) { imageWhiteTransparentOrigin = ""; }

                                // イメージが存在しているか？
                                var foundIndex = -1;
                                for(var j = 0; j < images.length; ++j)
                                {
                                    if(image == images[j])
                                    {
                                        // 存在
                                        foundIndex = j;
                                        break;
                                    }
                                }
                                if(foundIndex >= 0)
                                {
                                    // イメージが存在している
                                    map[layer.id] = foundIndex;
                                }
                                else
                                {
                                    // イメージが存在していない
                                    images.push(image);
                                    imagesWhiteTransparent.push(imageWhiteTransparent);
                                    imagesOrigin.push(imageOrigin);
                                    imagesWhiteTransparentOrigin.push(imageWhiteTransparentOrigin);
                                    map[layer.id] = images.length - 1;
                                }
                            }
                        }
                    }
                }
            }
        }

        // エンコードデータを保持
        document.layerImageData = images;
        document.layerImageDataWhiteTransparent = imagesWhiteTransparent;
        document.layerImageDataOrigin = imagesOrigin;
        document.layerImageDataWhiteTransparentOrigin = imagesWhiteTransparentOrigin;

        document.layerImageMap = map;
    }

    // ドキュメントに含まれる画像ファイルをデコードする
    public static decodeDocumentImage(document : Document)
    {
        for(var pageIndex = 0; pageIndex < document.pageCount; ++pageIndex)
        {
            var page = document.pageList[pageIndex];
            for(var surfaceIndex = 0; surfaceIndex < (page.hasReverse ? 2 : 1); ++surfaceIndex)
            {
                var surface = page.getSurface(surfaceIndex == 1);
                for(var designIndex = 0; designIndex < page.designMaxNumber; ++designIndex)
                {
                    var design = surface.getDesign(designIndex);
                    if(design != null)
                    {
                        var allLayers = design.getAllLayers(false);
                        for(var i = 0; i < allLayers.length; ++i)
                        {
                            var layer = allLayers[i];
                            if(layer instanceof ImageLayer)
                            {
                                if(layer.imageBase64 == "" || layer.imageBase64WhiteTransparent == "")
                                {
                                    // ドキュメントから復帰する
                                    if(document.layerImageMap[layer.id] != null)
                                    {
                                        var index = document.layerImageMap[layer.id];
                                        if(0 <= index && index < document.layerImageData.length)
                                        {
                                            layer.imageBase64 = document.layerImageData[index];
                                            layer.imageBase64WhiteTransparent = document.layerImageDataWhiteTransparent[index];
                                            layer.imageBase64Origin = (document.layerImageDataOrigin[index] != null && document.layerImageDataOrigin[index] != "") ?
                                                document.layerImageDataOrigin[index] :
                                                layer.imageBase64;
                                            layer.imageBase64WhiteTransparentOrigin = (document.layerImageDataWhiteTransparentOrigin[index] != null && document.layerImageDataWhiteTransparentOrigin[index] != "") ?
                                                document.layerImageDataWhiteTransparentOrigin[index] :
                                                layer.imageBase64WhiteTransparent;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        // 新形式になるので消去
        document.layerImageData = [];
        document.layerImageDataWhiteTransparent = [];
        document.layerImageDataOrigin = [];
        document.layerImageDataWhiteTransparentOrigin = [];
        document.layerImageMap = {};
    }

    // TableLayerの情報を元にコンバートする
    // TableLayer(文字入力あり) => GroupLayer (table, simpleText)
    // TableLayer(文字入力なし) => table
    public static convertTableLayer(jsonData : any) : GroupLayer | TableLayer
    {
        let tableLayer = TableLayer.createFromJsonData(jsonData);

        if(jsonData.layerVersion != null && jsonData.layerVersion >= 2)
        {
            // TableLayerは新形式なので、このまま返す
            return tableLayer;
        }

        let x = tableLayer.originX;
        let y = tableLayer.originY;
        let width = tableLayer.width;
        let height = tableLayer.height;
        let horizontalAlignment = (jsonData.horizontalAlignment != null) ? jsonData.horizontalAlignment : 0;
        let verticalAlignment = (jsonData.verticalAlignment != null) ? jsonData.verticalAlignment : 0;
        let textOrientation = (jsonData.textOrientation != null) ? jsonData.textOrientation : 0;

        let textLayers : Array<SimpleTextLayer> = [];

        if(jsonData.cellInfoMap != null)
        {
            let curX = x;
            let curY = y;
            for(let r = 0; r < jsonData.cellInfoMap.length; ++r)
            {
                for(let c = 0; c < jsonData.cellInfoMap[r].length; ++c)
                {
                    // 旧形式でロード
                    let oldTableCellInfo = TableCellInfo.createFromJsonData(jsonData.cellInfoMap[r][c]);
                    let textX = curX;
                    let textY = curY;
                    let textWidth = width * oldTableCellInfo.cellWidthNormalized / 100;
                    let textHeight = height * oldTableCellInfo.cellHeightNormalized / 100;
                    let text = oldTableCellInfo.text;
                    if(text != "")
                    {
                        // テキストが存在している時のみ。
                        // 旧形式の情報を元にしてSimpleTextLayerを作成する
                        let textLayer = SimpleTextLayer.create(text, textX, textY, textWidth, textHeight);
                        textLayer.name = tableLayer.name + "_文字";
                        textLayer.horizontalAlignment = horizontalAlignment;
                        textLayer.verticalAlignment = verticalAlignment;
                        textLayer.textOrientation = textOrientation;
                        textLayer.baseTextInfo.fontId = oldTableCellInfo.fontId;
                        textLayer.baseTextInfo.textColor = oldTableCellInfo.textColor;
                        textLayer.baseTextInfo.fontSize = oldTableCellInfo.fontSize;
                        textLayer.autoSize = oldTableCellInfo.autoSize;
                        textLayer.autoNewLine = oldTableCellInfo.autoNewLine;
                        textLayer.baseTextInfo.letterSpacing = oldTableCellInfo.letterSpacing;
                        textLayer.baseTextInfo.isShadow = oldTableCellInfo.isShadow;
                        textLayer.baseTextInfo.shadowColor = oldTableCellInfo.shadowColor;
                        textLayer.baseTextInfo.shadowDistance = oldTableCellInfo.shadowDistance;
                        textLayer.baseTextInfo.shadowRotate = oldTableCellInfo.shadowRotate;
                        textLayer.baseTextInfo.shadowBlur = oldTableCellInfo.shadowBlur;
                        textLayer.baseTextInfo.shadowIntensity = oldTableCellInfo.shadowIntensity;
                        textLayer.baseTextInfo.isOutline = oldTableCellInfo.isOutline;
                        textLayer.baseTextInfo.outlineColor = oldTableCellInfo.outlineColor;
                        textLayer.baseTextInfo.outlineThickness = oldTableCellInfo.outlineThickness;
                        textLayer.baseTextInfo.outlineIntensity = oldTableCellInfo.outlineIntensity;
                        // 自動サイズ強制更新をしてほしいので、autoFontSizeを0にする
                        textLayer.autoFontSize = 0;
                        // SimpleTextLayerを保持する
                        textLayers.push(textLayer);
                    }

                    curX += textWidth;
                    if(c == jsonData.cellInfoMap[r].length - 1)
                    {
                        curY += textHeight;
                    }
                }
                curX = x;
            }
        }

        if(textLayers.length > 0)
        {
            // TableLayerとSimpleTextLayerをグループにまとめる
            let groupLayer = GroupLayer.create();
            groupLayer.name = tableLayer.name;
            groupLayer.addLayer(tableLayer);
            for(let i = 0; i < textLayers.length; ++i)
            {
                groupLayer.addLayer(textLayers[i]);
            }

            // 回転反映
            let rotate = tableLayer.rotate;
            tableLayer.rotate = 0;
            groupLayer.rotate = rotate;

            return groupLayer;
        }
        else
        {
            // TableLayerをそのまま返す
            return tableLayer;
        }
    }

    // ドキュメントのサムネイル画像をすべて生成する
    // private static createDocumentThumbnailImage(document : Document, completion : () => void)
    // {
    //     this.createDocumentThumbnailImageCore(document, 0, 0, 0, completion);
    // }

    // private static createDocumentThumbnailImageCore(document : Document, pageIndex : number, surfaceIndex : number, designPosition : number, completion : () => void)
    // {
    //     var page = document.pageList[pageIndex];
    //     var surface = page.getSurface(surfaceIndex == 1);
    //     var design = surface.getDesign(designPosition);

    //     var comp = () =>
    //     {
    //         // デザインのサムネイルを作成したあとの処理

    //         var doCompletion = false;

    //         // デザインを一つすすめる
    //         designPosition++;
    //         if(designPosition >= page.designMaxNumber)
    //         {
    //             // デザインの最大数を超えたら、デザインを戻して面を進める
    //             designPosition = 0;
    //             surfaceIndex++;
    //             if(surfaceIndex >= (document.hasReverseSurface ? 2 : 1))
    //             {
    //                 // 面の最大数を超えたら、面を戻してページを進める
    //                 surfaceIndex = 0;
    //                 pageIndex++;
    //                 if(pageIndex >= document.pageCount)
    //                 {
    //                     // ページの最大数を超えたら、完了処理
    //                     doCompletion = true;
    //                     completion();
    //                 }
    //             }
    //         }

    //         if(!doCompletion)
    //         {
    //             // 次のデザインのサムネイル作成
    //             this.createDocumentThumbnailImageCore(document, pageIndex, surfaceIndex, designPosition, completion);
    //         }
    //     };

    //     if(design != null)
    //     {
    //         this.createDesignThumbnailImage(design, comp);
    //     }
    //     else
    //     {
    //         comp();
    //     }
    // }

    // デザインのサムネイル画像を必要あれば生成する
    // private static createDesignThumbnailImage(design : Design, completion : () => void)
    // {
    //     if(design.thumbnailImageBase64 == "" && design.thumbnailSvg != "")
    //     {
    //         // 生成する
    //         ImageHelper.svg2png(design.thumbnailSvg, design.thumbnailImageWidth, design.thumbnailImageHeight, (img) =>
    //         {
    //             if(design.thumbnailSvgRotate % 360 == 0)
    //             {
    //                 // 回転しない
    //                 design.thumbnailImageBase64 = img;
    //                 design.thumbnailSvg = "";
    //                 completion();
    //             }
    //             else
    //             {
    //                 // 回転する
    //                 ImageHelper.rotateImage(img, -design.thumbnailSvgRotate, (rotatedImg) =>
    //                 {
    //                     design.thumbnailImageBase64 = rotatedImg;
    //                     design.thumbnailSvg = "";
    //                     completion();
    //                 });
    //             }
    //         });
    //     }
    //     else
    //     {
    //         // 生成しない
    //         completion();
    //     }
    // }
}
